import { createSelector } from 'reselect';
import { property } from 'lodash';

const appIsReadyCheckData = property('appIsReadyCheck');

export const isLoadingSelect = createSelector(appIsReadyCheckData, (data) => data.get('loading'));

export const appIsReadySelect = createSelector(
  appIsReadyCheckData,
  (data) => data.get('data')?.ready,
);

export const errorSelect = createSelector(appIsReadyCheckData, (data) => data.get('error'));
